import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
   selectedDate: moment().startOf("day"),
   vaultAllOrganization: [],
   vaultOrgAccProductTable: [],
   valutOrgTableActionTrigger: false
};

export const VaultSlice = createSlice({
   name: "vault",
   initialState: initialState,
   reducers: {
      resetVaultState: (state) => {
         const { ...remainingState } = initialState;
         Object.assign(state, remainingState);
      },
      setSelectedDate: (state, action) => {
         state.selectedDate = action.payload;
      },
      setVaultAllOrganization: (state, action) => {
         state.vaultAllOrganization = action.payload;
      },
      setVaultOrgAccProductTable: (state, action) => {
         state.vaultOrgAccProductTable = action.payload;
      },
      setValutOrgTableActionTrigger: (state, action) => {
         state.valutOrgTableActionTrigger = action.payload;
      },
   },
});
